import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { orderUser } from "../../../services/orderService";
import { Link } from "react-router-dom";
import Loader from "../../../components/Loader";
import Pagination from "../../../components/Pagination";
import { useTranslation } from "react-i18next";

const Orders = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const { orders,loader ,pagination} = useSelector((state) => state.order);
  const { current_page, limit, total_items, total_pages } = pagination;

  const handlePaginate = (new_page) => {
    dispatch(orderUser({ page: new_page, limit }));
 };
  useEffect(() => {
    dispatch(orderUser({ page: current_page, limit }));
  }, [dispatch, current_page]);

 
  if(loader) return <Loader />
  
  return (
    <>
    <div className="grid grid-cols-1 gap-4 mb-4">
      <h2>{t('order.myOrder')}</h2>
      {orders?.length > 0 ? (
        <table className="w-full text-sm text-left rtl:text-right text-gray-900">
          <thead className="text-xs uppercase  border-b-2 border-gray-200 bg-gray-100 text-gray-900">
            <tr>
              <th scope="col" className="px-6 py-3">
              {t('order.orderId')}
              </th>
              <th scope="col" className="px-6 py-3">
              {t('order.orderDate')}
              </th>
              <th scope="col" className="px-6 py-3">
              {t('order.total')}
              </th>
              <th scope="col" className="px-6 py-3">
              {t('order.status')}
              </th>
              <th scope="col" className="px-6 py-3">
              {t('order.action')}<span className="sr-only">{t('order.detail')}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.id} className="bg-white border-b hover:bg-gray-100">
                <td className="px-6 py-4">{order.id}</td>
                <td className="px-6 py-4">{order.createdAt}</td>

                <td className="px-6 py-4">{order.totalAmount}</td>
                <td className="px-6 py-4"><span className={`px-4 py-2 link-${order.status}`}>{order.status}</span></td>
                <td className="px-6 py-4 text-center">
                  <Link to={`/user/orders/${order.id}`} className="bg-primaryColor  text-white font-bold py-2 px-4">{t('order.detail')}</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>{t('order.orderNotFound')}</p>
      )}
    </div>
    <Pagination
        current_page={current_page}
        total_pages={total_pages}
         handlePaginate={handlePaginate}
      />
    </>
    
  );
};

export default Orders;
